import { render, staticRenderFns } from "./CreateAdminAccount.vue?vue&type=template&id=da051b02&"
import script from "./CreateAdminAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAdminAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports